export default __webpack_public_path__ + "static/media/kid-6.68dd6f80.JPG";